<template>
  <div>
    <!-- 会员列表详情开始 -->
    <el-dialog :close-on-click-modal="false"
      title="会员详情"
      :visible.sync="cardInfoVisible"
      :before-close="cardInfoHandleClose"
      width="76.3%"
      center
    >
      <el-divider></el-divider>
      <div class="infoForm">
        <el-form ref="form" :model="form" label-width="90px">
          <div class="itemOne">
            <el-form-item label="会员姓名:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item label="ID:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item label="级别:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item label="注册时间:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item label="邀请人:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
          </div>
          <div class="itemTwo">
            <el-form-item label="联系方式:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item label="自推订单量:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">单</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="邀请人数:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">人</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="推荐订单:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">单</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="未激活会员:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">人</slot>
                </template>
              </el-input>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="自推收入:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="管理佣金:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="累计收入:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="已提现:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="余额:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="tab">
        <span
          v-for="(v,i) in tabBtn"
          :key="v.id"
          @click="tabTitle(i)"
          :class="activeIndex==i?'activeTab':''"
        >{{v.name}}</span>
      </div>
      <div v-if="activeIndex==0">
        <div>
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColorLeft"
            :cell-style="cellStyleLeft"
            style="width: 100%"
          >
            <el-table-column prop="date" label="邀请时间"></el-table-column>
            <el-table-column prop="name" label="ID"></el-table-column>
            <el-table-column prop="address" label="会员名称"></el-table-column>
            <el-table-column prop="address" label="级别">
              <template slot-scope="scope">
                <img src="@/images/scenic/jh.png" alt />
                <img src="@/images/scenic/wjh.png" alt />
                <span style="margin-left:10px">{{scope.row.address}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="联系方式"></el-table-column>
            <el-table-column prop="address" label="注册时间"></el-table-column>
            <el-table-column prop="address" label="自推订单"></el-table-column>
            <el-table-column prop="address" label="管理佣金"></el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <div v-if="activeIndex==1">
        <div>
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColorLeft"
            :cell-style="cellStyleLeft"
            style="width: 100%"
          >
            <el-table-column prop="date" label="自推时间"></el-table-column>
            <el-table-column prop="name" label="订单名称"></el-table-column>
            <el-table-column prop="address" label="销售佣金单价"></el-table-column>
            <el-table-column prop="address" label="销售数量"></el-table-column>
            <el-table-column prop="address" label="合计"></el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
    </el-dialog>
    <!-- 会员列表详情结束 -->

    <!-- 返佣设置驳回详情开始 -->
    <!-- 会员列表详情开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="rejectInfoType"
      :visible.sync="rejectInfoVisible"
      :before-close="rejectInfoHandleClose"
      width="46.5%"
      center
    >
      <el-divider></el-divider>
      <div class="rejectForm">
        <el-form ref="form" :model="form" label-width="90px">
          <div class="itemOne">
            <el-form-item label="时间:">
              <el-date-picker v-model="value1" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="ID:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item label="级别:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
          </div>
          <div class="itemTwo">
            <el-form-item label="会员名称:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item label="联系方式:">
              <el-input v-model="form.name" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item label="累计佣金:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="已提现金额:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="申请金额:">
              <el-input v-model="form.name" placeholder="--">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
          </div>
          <el-divider></el-divider>
          <div class="itemFour">
            <el-form-item label="驳回理由:">
              <el-input
                type="textarea"
                :autosize="{minRows:3,maxRows:5}"
                v-model="form.name"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <div class="itemFive">
              <el-form-item label="状态:">
                <el-input v-model="form.name" placeholder="--"></el-input>
              </el-form-item>
              <el-form-item label="审核时间:">
                <el-date-picker v-model="value1" type="datetime" placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
            </div>
            <div class="itemSex">
              <el-form-item label="审核人:">
                <el-input v-model="form.name" placeholder="--"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item class="itemBtn">
            <el-button>删除</el-button>
            <el-button class="btnL">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 返佣设置驳回详情结束 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardInfoVisible: false, // 会员列表详情
      rejectInfoVisible: false, // 返佣设置驳回详情
      rejectInfoType: "",
      form: {
        name: ""
      },
      tabBtn: [
        {
          id: 1,
          name: "邀请列表"
        },
        {
          id: 2,
          name: "自推订单"
        }
      ],
      activeIndex: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      value1: ""
    };
  },
  methods: {
    // 返佣设置驳回详情
    rejectInfo(row, num) {
      if (num == 11) {
        this.rejectInfoType = "驳回";
      }
      if (num == 22) {
        this.rejectInfoType = "详情";
      }
      this.rejectInfoVisible = true;
    },
    // 返佣设置驳回详情X
    rejectInfoHandleClose() {
      this.rejectInfoVisible = false;
    },
    // 会员列表详情
    cardInfo(row) {
      this.cardInfoVisible = true;
    },
    // 会员列表详情X
    cardInfoHandleClose() {
      this.cardInfoVisible = false;
    },
    tabTitle(index) {
      // console.log(index);
      this.activeIndex = index;
      console.log(this.activeIndex);
    },
    // 文字左对齐表头设置
    tableHeaderColorLeft({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColorLeft({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyleLeft({ row, rowIndex }) {
      return this.utils.cellStyleLeft({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less'scoped>
.rejectForm {
  margin-top: 20px;
  /deep/.el-form-item {
    margin-bottom: 20px;
  }
  .itemOne {
    display: flex;
    .el-input {
      width: 195px;
    }
    .el-date-editor {
      width: 195px;
    }
  }
  .itemTwo {
    display: flex;
    .el-input {
      width: 195px;
    }
  }
  .itemThree {
    display: flex;
  }
  .itemFour {
    margin-top: 20px;
  }
  .itemFive {
    margin-top: 20px;
    display: flex;
    .el-input {
      width: 335px;
    }
  }
  .itemSex {
    .el-input {
      width: 335px;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-left: -90px;
    margin-top: 40px;

    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
      margin-right: 10px;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
}
.tab {
  width: 60%;
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
.infoForm {
  margin-top: 20px;
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .itemOne {
    display: flex;
  }
  .itemTwo {
    display: flex;
    .el-input {
      width: 182px;
    }
  }
  .itemThree {
    display: flex;
    .el-input {
      width: 182px;
    }
  }
}
/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 30px auto 10px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>